export default function StatusFilterTabs({ filters = [], active, onChange }) {
  return (
    <div
      className="
        w-full
        sm:w-auto
        overflow-x-auto
        sm:overflow-visible
        scrollbar-hide
      "
    >
      <div
        className="
          inline-flex
          sm:flex
          gap-1 sm:gap-2
          bg-[#F3F6F9]
          rounded-xl
          p-2 sm:p-3
          px-3 sm:px-4
          min-w-max
          sm:min-w-0
        "
      >
        {filters.map((f) => (
          <button
            key={f}
            onClick={() => onChange(f)}
            className={`
              flex-shrink-0
              px-4 sm:px-5
              py-1.5 sm:py-2
              rounded-lg
              text-xs sm:text-sm
              font-medium
              transition
              whitespace-nowrap
              ${
                active === f
                  ? "bg-[#00C2C7] text-white shadow"
                  : "text-gray-700 hover:bg-white/70"
              }
            `}
          >
            {f}
          </button>
        ))}
      </div>
    </div>
  );
}
